import moment from 'moment';
import SourceSession, {
  AttendanceMap as SourceAttendance,
} from 'sources/sourceTypes/Session';
import Session, { AttendanceMap } from 'types/Session';

const attendanceMapToType = (obj: SourceAttendance): AttendanceMap => {
  const att = new AttendanceMap();
  if (obj) {
    att.booked = obj.booked;
    att.checkedIn = obj.checked_in;
  }
  return att;
};

export const toSource = (_obj: Session): SourceSession => {
  return new SourceSession();
};

export const toType = (sourceObj: SourceSession): Session => {
  const session = new Session();
  session.id = sourceObj.id;
  session.eventId = sourceObj.event_id;
  session.startsAt = moment(sourceObj.starts_at);
  session.endsAt = moment(sourceObj.ends_at);
  session.clientIds = sourceObj.client_ids;
  session.staffIds = sourceObj.staff_ids;
  session.resourceIds = sourceObj.resource_ids;
  session.registrationIds = sourceObj.registration_ids;
  session.scheduleId = sourceObj.schedule_id;
  session.status = sourceObj.status;
  session.createdAt = moment(sourceObj.created_at);
  session.updatedAt = moment(sourceObj.updated_at);
  session.attendanceMap = attendanceMapToType(sourceObj.attendance_map);

  return session;
};
